import { render, staticRenderFns } from "./27htmlText.vue?vue&type=template&id=77367a45&scoped=true&"
import script from "./27htmlText.vue?vue&type=script&lang=js&"
export * from "./27htmlText.vue?vue&type=script&lang=js&"
import style0 from "./27htmlText.vue?vue&type=style&index=0&id=77367a45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77367a45",
  null
  
)

export default component.exports